import { axiosInstance } from "@/axios/axiosInstance";
import { Client, ClientPurchase } from "@/types/client";
import { PaginatedResponse, QueryParamsBase } from "@/types/types";

export const getClients = async (
  params?: QueryParamsBase & { select?: string[] },
): Promise<PaginatedResponse<Client>> => {
  const { data } = await axiosInstance.get("/customers", {
    params,
  });
  return data;
};

export const getClientPurchases = async (
  customer_id: Client["id"],
  params?: QueryParamsBase & { select?: string[] },
): Promise<PaginatedResponse<ClientPurchase>> => {
  const { data } = await axiosInstance.get(
    `/customers/${customer_id}/purchases`,
    {
      params,
    },
  );
  return data;
};

export async function deleteClient(id: Client["id"]) {
  const { data } = await axiosInstance.delete(`/customers/${id}`);
  return data;
}

//store
export async function createClient(values: Client) {
  const { data } = await axiosInstance.post(`/customers`, values);
  return data;
}

//update
export async function updateClient(values: Client) {
  const { data } = await axiosInstance.patch(`/customers/${values.id}`, values);
  return data;
}

// export
export async function exportClientPurchases(
  customer_id: Client["id"],
  tableParams: QueryParamsBase,
) {
  const { data } = await axiosInstance.get(
    `/customers/${customer_id}/purchases/export`,
    {
      params: tableParams,
    },
  );
  return data;
}

// pay credit
export async function payClientCredit(
  customer_id: Client["id"],
  payload: { payment_ids: string[]; invoice_number: string },
) {
  const { data } = await axiosInstance.post(
    `/customers/${customer_id}/pay-credit`,
    payload,
  );
  return data;
}
